var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandsetInstallments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19h8M18.5 16h-13",
    stroke: "#5BC231",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.396 7.2c0-.196-.012-.386 0-.575a.575.575 0 0 1 .16-.437A.601.601 0 0 1 11.99 6a.615.615 0 0 1 .439.18.585.585 0 0 1 .168.434c.015.189 0 .38 0 .622.24 0 .435-.01.627 0a.628.628 0 0 1 .45.167.601.601 0 0 1 .189.433.566.566 0 0 1-.199.428.595.595 0 0 1-.458.143c-.58.01-1.16 0-1.74.005a1.59 1.59 0 0 0-.391.035.493.493 0 0 0-.279.186.472.472 0 0 0 .05.617c.08.08.189.13.304.141.276.022.552.007.829.014.355-.004.71.01 1.064.043.402.053.771.246 1.04.545.267.298.415.68.416 1.077.003.402-.143.79-.412 1.096-.268.304-.64.504-1.047.562-.129.02-.257.04-.437.07 0 .196.01.387 0 .575a.575.575 0 0 1-.159.438.602.602 0 0 1-.435.189.615.615 0 0 1-.439-.178.587.587 0 0 1-.17-.434c-.015-.189 0-.38 0-.597-.173-.01-.3-.022-.428-.025-.552-.011-.846-.222-.838-.605.007-.384.297-.58.86-.583h1.502c.105.003.21 0 .316-.008a.503.503 0 0 0 .337-.15.48.48 0 0 0-.004-.674.504.504 0 0 0-.339-.147c-.13-.014-.263-.006-.395-.009-.46-.008-.92.007-1.38-.03a1.697 1.697 0 0 1-1.078-.513A1.62 1.62 0 0 1 9.5 8.964c-.009-.39.121-.77.369-1.076a1.72 1.72 0 0 1 .986-.599c.16-.034.327-.056.54-.09z",
    fill: "#5BC231"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 2.75,
    width: 19.5,
    height: 19.5,
    rx: 2.25,
    stroke: "#5BC231",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1v3M9.5 1v3M13.5 1v3M17.5 1v3",
    stroke: "#5BC231",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsetInstallments);
export default __webpack_public_path__ + "static/media/handsetInstallments.b6997c281fbdf0314d123b798bf9752f.svg";
export { ForwardRef as ReactComponent };